module.exports = __webpack_public_path__ + "static/deep_scion-a5146b54a7ace7b7005eb93681f4fb60.jpeg";